function loadBenefit() {
  var box=document.querySelector(".benefit .box")
  var item = document.querySelectorAll(".benefit .box .item");
  var next = document.querySelector(".benefit .next");
  var prev = document.querySelector(".benefit .prev");
  var contentWidth = document.querySelector(".benefit .content");
  var maxWidth=item[0].offsetWidth * item.length + 20 * (item.length - 1);

  var index = 0;

  var timer;
  box.style.width = item[0].offsetWidth * item.length + 20 * (item.length - 1)+2 + "px";

  function animate() {
    box.style.left = -parseInt(item[0].offsetWidth +3)* index + "px";
  }

  next.onclick = function () {
    index ++;
    if(index>=item.length){
      box.style.left = "0px";
      index=0
    }
    if(maxWidth-parseInt((item[0].offsetWidth) * index)<contentWidth.offsetWidth){
      box.style.left = -(maxWidth-contentWidth.offsetWidth+2) + "px";

      index=item.length-1
    }else{
      animate()
    }
  }

  prev.onclick = function () {
    index --;
    if(index==-1){
      box.style.left = -(maxWidth-contentWidth.offsetWidth+2) + "px";
      index=item.length-2
    }else{
      animate()
    }
  }
  // function play() {
  //   timer = setInterval(function () {
  //     if(document.body.clientWidth>768){
  //       next.onclick()
  //     }
  //   },5500);
  // }
  
  // play()
}

export {
  loadBenefit
}


// WEBPACK FOOTER //
// ./src/views/promotion/Netflix/Benefit.js